import { render, staticRenderFns } from "./InstituteProfileAttachedQuestions.vue?vue&type=template&id=19fc42a8"
import script from "./InstituteProfileAttachedQuestions.vue?vue&type=script&lang=js"
export * from "./InstituteProfileAttachedQuestions.vue?vue&type=script&lang=js"
import style0 from "./InstituteProfileAttachedQuestions.vue?vue&type=style&index=0&id=19fc42a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports